import React, { useContext } from 'react';
import background from '../../assets/images/background.jpg';
import arnolds from '../../assets/images/logos/Arnold-Ventures_logo.png';
import calmatters from '../../assets/images/logos/calmatters.png';
import civilbeat from '../../assets/images/logos/civil-beat-logo.png';
import calpoly from '../../assets/images/logos/calpoly_logo.png';
import iatpp from '../../assets/images/logos/IATPP_logo.png';
import knight from '../../assets/images/logos/knight_logo.png';
import miami from '../../assets/images/logos/university-of-miami_logo.png';
import graz from '../../assets/images/logos/TUGraz.png';
import tenup from '../../assets/images/logos/10up-logo.png';
import { HostInfoContext } from '../../hooks/HostInfoContext';
import { getBaseUrl } from '../Stories/Links';
import styled from 'styled-components';

const AboutWrap = styled.div`
  background-color: #e5e5e5;
  min-width: 300px;
`;

const AboutBox = styled.div`
  display: block;
  border-radius: 10px;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  background: white;
  min-height: 245px;
  width: 500px;
  position: absolute;
  top: 20%;
  left: 50%;
  padding: 10px;
  margin-top: -50px;
  margin-left: -250px;
  justify-content: center;
  align-items: center;
`;

const LogosBox = styled.div`
  display: block;
  clear: both;
  text-align: center;
  align-items: center;
  padding-top: 50px;

  & img {
    height: 50px;
    padding: 5px;
    margin-left: 5px;
    margin-right: 5px;
  }
`;

// Partner logo mapping - add new partners here as needed
const PARTNER_LOGOS = {
  'CalMatters': calmatters,
  'Honolulu Civil Beat': civilbeat,
  // Add more partners here in the future
  // 'New Partner Name': newPartnerLogo,
};

const getLogosConfig = (partner) => {
  const firstLogo = PARTNER_LOGOS[partner] || calmatters;
  return {
    standard: [firstLogo, arnolds, knight, graz, tenup],
    small: [miami, calpoly],
    reduced: [iatpp],
  };
};

const Logo = ({ src, size }) => {
  const styles = {
    small: { height: '60px', paddingTop: '0px' },
    reduced: { height: '45px' },
    standard: {},
  };

  return <img alt="Partner logo" src={src} style={styles[size]} />;
};

const About = () => {
  const hostInfo = useContext(HostInfoContext);
  const partner = hostInfo?.PARTNER || 'CalMatters';
  const logosConfig = getLogosConfig(partner);

  const renderLogos = () => {
    return [
      ...logosConfig.standard.map((logo) => (
        <Logo key={logo} src={logo} size="standard" />
      )),
      ...logosConfig.small.map((logo) => (
        <Logo key={logo} src={logo} size="small" />
      )),
      ...logosConfig.reduced.map((logo) => (
        <Logo key={logo} src={logo} size="reduced" />
      )),
    ];
  };

  return (
    <AboutWrap>
      <div style={{ backgroundImage: `url(${background})` }}>
        <AboutBox>
          <p>
            AI Tip Sheets is part of{' '}
            <a href={`${getBaseUrl()}/about-digital-democracy`}>
              Digital Democracy
            </a>{' '}
            by {partner}. It was developed at the Cal Poly Institute for
            Advanced Technology and Public Policy over several years in
            collaboration with {partner}, Cal Poly, 10UP, Graz University of
            Technology and University of Miami. Major funding provided by{' '}
            {partner}, Arnold Ventures and Knight Foundation.
          </p>
          <LogosBox>{renderLogos()}</LogosBox>
        </AboutBox>
      </div>
    </AboutWrap>
  );
};

export default About;
